import { css } from '@emotion/css';
import CompanyLogo from '../../assets/img/logo/zcorp_logo.png';

const useStyles = () => {
  return css({
    width: 'auto',
    height: 27,
  })
};


const Logo = () => {
  const classes = useStyles();
  return <img className={classes} src={CompanyLogo} />;
};

export default Logo;